import { render, staticRenderFns } from "./NewDoctor.vue?vue&type=template&id=8baca39c&scoped=true"
import script from "./NewDoctor.vue?vue&type=script&lang=js"
export * from "./NewDoctor.vue?vue&type=script&lang=js"
import style0 from "./NewDoctor.vue?vue&type=style&index=0&id=8baca39c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8baca39c",
  null
  
)

export default component.exports